<template>
<content-div>

  <div class="svTitArea subscribe guideSubsc">
    <!-- <div class="titCon">
      <h2 class="svTit">서비스는 공식, 안심도 정식으로</h2>
      <p class="svTitSub">
        합리적인 가격의 차량 관리 안심 솔루션<br>
        BMW ServiceCare+
      </p>
    </div> -->
  </div>

  <!-- <div class="sub_copy alignC" style="margin: 15px 0 15px 0;">
    <p class="sub_copy_txt">
      ServiceCare+는 BMW Plus 앱을 통해<br>
      구독 신청이 가능합니다.
    </p>
  </div> -->
  <div class="sub_copy alignC" style="margin: 15px 0 15px 0;">
    <p class="sub_copy_txt">
      편리하고 스마트한 BMW Plus App에서<br>
      BMW ServiceCare+를 지금 만나보세요.
    </p>
  </div>

  <div class="subBlock" style="margin:0px;">
    <div class="tabType3 noSidePadding">
      <ul>
        <li v-for="(item, key) in pkgs" :key="key" :class="{'on': selected.group === key }">
          <a @click="changeTab(key)"><span>{{item.group}}</span></a>
        </li>
      </ul>
    </div>
  </div>

  <div class="contArea">
    <swiper class="swiper app_book" :options="swiperOption" style="margin-top:0px;">
      <swiper-slide class="item" v-for="(item,idx) in contents" :key="item.id">
        <div class="app_book_img">
          <img :src="`${$store.state.dir}images/step/STEP${item.id + (item.id == 2 ? selected.group == 1 ? '_2' : '_1' : '')}.png`">
        </div>

				<!--0323추가-->
				<div class="blank_slide">

					<div class="text">
						<dl>
							<dt>Step{{idx+1}}.</dt>
							<dd>{{item.title}}</dd>
						</dl>

            <!--0<p v-if="item.insurance" style="line-height:unset !important;">
              (*{{$store.state.insuranceName}}<br>미선택 고객은 생략)
            </p>-->

					</div>
				</div>
				<!--0323추가-->
      </swiper-slide>


      <div v-if="isFraction" class="swiper-button-prev" slot="button-prev"></div>
      <div v-if="isFraction" class="swiper-button-next" slot="button-next"></div>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>

    <button-app-download v-if="!$store.state.isApp"></button-app-download>

	</div>
</content-div>
</template>

<script>
import ButtonAppDownload from '@/components/Button/ButtonAppDownload.vue'

export default {
  name: 'GuideSubscApply',
  components: {
    ButtonAppDownload,
  },
  data() {
    return {
      pkgs: [
        {id: 0, group: 'STANDARD/PREMIUM'},
        {id: 1, group: 'POWER TRAIN'},
      ],
      groups: [],
      selected: {
        group: 0
      },
      swiperOption: {
        loop: false,
        slidesPerView: 2, //화면에 slide 노출 개수
        spaceBetween: 5, //거리
        pagination:{
          el: '.swiper-pagination',
          type: 'bullets',
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      isFraction: false,
    }
  },
  computed: {
    contents() {
      let returnList = null;

      let contents = [
        { id:1, title: 'BMW Vantage App 접속', insurance: false, },  // 2024-03-11
        { id:2, title: 'ServiceCare+ 초기화면', insurance: false, },
        { id:3, title: '서비스 신청 & 구비서류 준비', insurance: true, },
        { id:4, title: '차량정보 확인', insurance: false, },
        { id:5, title: '가입 대상 여부 확인', insurance: true, },
        { id:6, title: '차량등록증 촬영', insurance: true, },
        { id:7, title: '자동차정기검사결과표 촬영', insurance: true, },
        { id:8, title: '자동차 계기판 촬영', insurance: true, },
        { id:9, title: '간편 결제를 통한 구매 완료', insurance: false, },
      ];

      if(this.selected.group == 0) {
        returnList = contents.filter(e=> e.insurance == false);
      } else {
        returnList = contents;
      }

      return returnList;
    },
  },
  methods: {
    changeTab(selectPkgGroup) {
      if(selectPkgGroup == undefined || selectPkgGroup == null) selectPkgGroup = 0;
      
      this.selected.group = selectPkgGroup;
      this.tglOn = true;

      let mySwiper = document.querySelector('.swiper-container').swiper
      mySwiper.slideTo(this.groups.indexOf(selectPkgGroup));
    },
  },
};
</script>

<style scoped>
.swiper-pagination {
  position: initial;
}
.swiper-button-prev, .swiper-container-rtl .swiper-button-next {
  background-image: none;
}
.swiper-button-next, .swiper-container-rtl .swiper-button-prev {
  background-image: none;
}

.swiper-button-prev.swiper-button-disabled {
  display: none;
}
.swiper-button-next.swiper-button-disabled {
  display: none;
}

.svTitSub {
  color:#fff;
  font-size:12px;
  line-height: 20px;
  text-align: center;
  margin-top: 20px;
}
</style>